import script from "./navigationHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./navigationHeader.vue?vue&type=script&setup=true&lang=js"

import "./navigationHeader.vue?vue&type=style&index=0&id=1dd21902&lang=scss&scoped=true"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dd21902"]])

export default __exports__